module.exports = __webpack_public_path__ + "static/mobile2-413bec77d29adc60ba2fbf1e335cd661.png";